import { getAllAttachmentsSize } from 'composer-data/attachments/public/operators';
import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import styled from 'styled-components';
import UploadedFile from './UploadedFile';
import UploadingFile from './UploadingFile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tray = styled.div.withConfig({
  displayName: "AttachmentTray__Tray",
  componentId: "sc-1sjtjr4-0"
})(["display:flex;overflow-x:auto;padding-right:12px;"]);
export default class AttachmentTray extends PureComponent {
  render() {
    const {
      attachments,
      indexedAsyncFileUploads,
      maxFileLimit,
      maxTotalFileSizeLimit,
      onRemoveFileUpload,
      onRemoveUploadedFile
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [attachments.size + indexedAsyncFileUploads.size > maxFileLimit && /*#__PURE__*/_jsx(Small, {
        className: "p-left-3",
        use: "error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.attachment.errors.files-limit-error",
          options: {
            maxFileLimit
          }
        })
      }), attachments && getAllAttachmentsSize(attachments) > maxTotalFileSizeLimit && /*#__PURE__*/_jsx(Small, {
        className: "p-left-3",
        use: "error",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.attachment.errors.total-file-size-error",
          options: {
            maxTotalFileSizeLimit: I18n.formatSize(maxTotalFileSizeLimit)
          }
        })
      }), /*#__PURE__*/_jsxs(Tray, {
        children: [indexedAsyncFileUploads.toList().toArray().map((asyncFileUpload, index) => /*#__PURE__*/_jsx(UploadingFile, {
          asyncFileUpload: asyncFileUpload,
          onRemove: onRemoveFileUpload
        }, `upload-${index}`)), attachments.toArray().map((attachment, index) => /*#__PURE__*/_jsx(UploadedFile, {
          uploadedFile: attachment,
          onRemove: onRemoveUploadedFile
        }, `attachment-${index}`))]
      })]
    });
  }
}
AttachmentTray.displayName = 'AttachmentTray';
AttachmentTray.propTypes = {
  attachments: ImmutablePropTypes.listOf(PropTypes.object),
  indexedAsyncFileUploads: ImmutablePropTypes.map.isRequired,
  maxFileLimit: PropTypes.number.isRequired,
  maxTotalFileSizeLimit: PropTypes.number,
  onRemoveFileUpload: PropTypes.func.isRequired,
  onRemoveUploadedFile: PropTypes.func.isRequired
};